import qs from '@/api/students.js'
import artic from '@/api/management.js'
import moment from 'moment'
import { async } from 'q';

const mount  =  (params) =>{
  return  moment(params).format('YYYY-MM-DD')
}
const chageWord = (params) =>{
    
        switch (params) {
            case 0:
        return '一星级'
            case 1:
        return'一星级'
            case 2:
        return '二星级'
            case 3:
        return '三星级' 
            case 4:
        return '四星级'
            case 5:
        return '五星级'
            case 6:
        return '六星级'
            case 7:
        return '七星级'
            case 8:
        return '八星级'
            case 9:
        return '九星级'
            case 10:
        return '十星级'        
        }
}
const chageStar = (params) =>{
    if(params > 0) {
        switch (params) {
            case 0:
        return ''
            case 1:
        return'一星级'
            case 2:
        return '二星级'
            case 3:
        return '三星级' 
            case 4:
        return '四星级'
            case 5:
        return '五星级'
            case 6:
        return '六星级'
            case 7:
        return '七星级'
            case 8:
        return '八星级'
            case 9:
        return '九星级'
            case 10:
        return '十星级'        
        }
    // } else {
    //     if (change>=8) {
    //         return '一星级'
    //     }else{
    //         return ' '
    //     }
       
    }
}
const  state={
    studentsList:{},
    tablist:[],
    state:'',
    total:'',
    achtablist :[],
    sClass:[], 
    school:[],
    page:''
    }
const mutations={
    page(state,labelList){
        state.page = labelList
    },
    total(state,labelList){
        state.total = labelList
    },
    class(state,labelList){
        console.log('到这了')
        state.sClass = []
        if (labelList ===undefined) {
            state.sClass = []
        } else {
            artic.classNmae.class({schoolId:labelList}).then(res =>{
                // eslint-disable-next-line no-console
             state.sClass = res.data.data
            console.log(res.data) 
            })
            console.log(state.sClass)
        }
    
     
    },
    school(state){
        console.log('阿萨德哈斯的活塞队撒')
        qs.school({asas:1}).then(res =>{
            state.school = res.data.data
            console.log(res)
        })
        console.log('阿萨德哈斯的活塞队撒')
    },
    students_score(state,labelList){
        state.studentsList = []
        labelList.forEach(item =>{
            // if (item.accuracy !=0) {
                state.studentsList.push({
                    '关卡名称':item.name,
                    '星级评价':item.score+'星',
                    '准确率':item.accuracy+'%',
                    // '阅读星级':chageStar(item.articleStar)
                })     
            // }
           
        })
     
        console.log(labelList)
        // state.studentsList = labelList.map({
        //     关卡名称:item.name
        // })
        artic.classNmae.class({asas:1}).then(res =>{
            // eslint-disable-next-line no-console
           state.sClass = res.data.data
        })
    },
    article_list(state,labelList){
        state.studentsList =[]
        labelList.forEach(item =>{
           state.studentsList.push({
            '星级':chageWord(item.star),
            '文章':item.name,
            '星级评价':item.score+'星',
            '答题情况':item.progress+'%'
           })
        })
        artic.classNmae.class({asas:1}).then(res =>{
            // eslint-disable-next-line no-console
           state.sClass = res.data.data
        })
    },
    students_list(state,labelList){
        state.studentsList = []
        
        labelList.forEach(item => {
            
                state.studentsList.push({
                    '学校': item.schoolName,
                    '班级': item.className,
                    'name': item.name,
                    '电话': item.phone,
                    '入学年份': item.year,
                    '指导教师': item.teacherName,
                    '教师联系电话': item.teacherPhone,
                    'wordAccuracy':item.wordAccuracy+'%',
                    'wordStar':chageWord(item.wordStar),
                    'articleStar':chageStar(item.articleStar,item.wordStar),
                    'updateTime': mount(item.updateTime),
                    studentId:item.id,
                    teacherId:item.teacherId,
                    schoolId:item.schoolId
                })
            
        });
        
       
        // console.log(state.school)
       
        // state.studentsList = labelList.map((item,index) => ())
        state.tablist =[
        { prop: '学校', label: '学校' },
        { prop: '班级', label: '班级' },
        { prop: 'name', label: '姓名' },
        { prop: '电话', label: '电话'},
        { prop: '入学年份', label: '入学年份'},
        { prop: '指导教师', label: '指导教师'},
        { prop: '教师联系电话', label: '教师联系电话'},
        { prop: 'wordAccuracy', label: '识字准确率'},
        { prop: 'wordStar', label: '识字星级'},
        { prop: 'articleStar', label: '阅读星级'},
        { prop: 'updateTime', label: '更新时间'},
        { slot: 'opt',label: '操作' }
    ]
       
    }
}
const  actions={
    'FETCH_STUDENTS_LIST': async({
        commit,
    },page) =>{
        let params = {
            page:1,
            pageSize:20,
          
        }
        if (page === undefined) {
          page = params
        } 
        const res  = await qs.studentsList(page)
        console.log('1212',page.school)
        commit('students_list',res.data.data.content) 
        commit('school')
        console.log(page.schoolId)
        if (page.schoolId === undefined || page.schoolId === null || page.schoolId === '' ) {
            commit('class',undefined)
        } else {
            console.log('别到这儿')
            commit('class',page.schoolId)
        }
       
        commit('total',res.data.data.total)
        commit('page', res.data.page)
        
       
    },
    'FETCH_CLASS':async({
        commit
    },page) =>{
        commit('class',page)
    },
    'FETCH_STUDENTS_SCORE': async({
        commit
    },page) =>{
        if (!page) {
            page.page =1
            page.pageSize = 20
            
        }
      
        const res = await qs.score(page)
        commit('page', res.data.page)
        commit('students_score',res.data.data.content)
        commit('total',res.data.data.total)
    },
    'FETCH_ARCT_LIST': async({
        commit
    },page) =>{
        if (page === undefined) {
            page.page =1
            page.pageSize = 20
            
        }
        const res = await artic.article.score(page)
        commit('page', res.data.page)
        commit('article_list',res.data.data.content)
        commit('total',res.data.data.total)
    },
    'SET_PRICE_CONFIG': async({
        commit
    }, money) =>{
        if (typeof(money) === 'number') await artic.priceConfig.set({
            money
        })
    }
    
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
